import React from "react";
import PropTypes from "prop-types";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 20,
    padding: 10,
    color: "#8ebe3f",
    "& .MuiStepLabel-iconContainer": {
      "& .MuiStepIcon-root.MuiStepIcon-active": {
        color: "#8ebe3f",
      },
    },
  },
  stepLabel: {
    fontSize: 16,
    marginTop: "5px !important",
  },
}));

const MonitoringStepper = ({ activeStep, steps }) => {
  const classes = useStyles();
  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      p={0}
      classes={{ root: classes.root }}
    >
      {steps.map((label, index) => {
        const stepProps = {};
        return (
          <Step key={index} {...stepProps} disabled={false}>
            <StepLabel classes={{ label: classes.stepLabel }}>
              {label}
            </StepLabel>
          </Step>
        );
      })}
    </Stepper>
  );
};

MonitoringStepper.propTypes = {
  activeStep: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(PropTypes.node).isRequired,
};

export default MonitoringStepper;
